import { type CSSProperties, Suspense } from 'react';
import { Outlet } from 'react-router';

import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar';
import { NavSidebar } from '@/layout/nav-sidebar.tsx';

const Layout = () => {
  return (
    <SidebarProvider
      style={
        {
          '--sidebar-width': 'calc(var(--spacing) * 72)',
          '--header-height': 'calc(var(--spacing) * 12)',
        } as CSSProperties
      }
    >
      <NavSidebar />
      <SidebarInset>
        <Suspense fallback={'Loading...'}>
          <Outlet />
        </Suspense>
      </SidebarInset>
    </SidebarProvider>
  );
};

export default Layout;
